<script lang="ts">
    import type { Availability } from '@shared/types/types';

    interface Props {
        availability: Availability | undefined;
    }

    let { availability }: Props = $props();

    const PREFIX = 'lieferbar - ';

    const detail = $derived.by(() => {
        const raw = availability?.detail;
        if (!raw) return undefined;
        return raw.startsWith(PREFIX) ? raw.slice(PREFIX.length) : raw;
    });
</script>

{#if detail}
    <span class="reptile-availability oc-copy-75" data-testid="AvailabilityText">
        {detail}
    </span>
{/if}
